import { render, staticRenderFns } from "./PlayBox.vue?vue&type=template&id=14bcfb40&scoped=true&lang=pug&"
import script from "./PlayBox.vue?vue&type=script&lang=js&"
export * from "./PlayBox.vue?vue&type=script&lang=js&"
import style0 from "./PlayBox.vue?vue&type=style&index=0&id=14bcfb40&scoped=true&lang=scss&"
import style1 from "./PlayBox.vue?vue&type=style&index=1&id=14bcfb40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bcfb40",
  null
  
)

export default component.exports